/* global Office */

export interface MailPreview {
  subject: string;
  sender: string;
}

export function getMailPreview(): MailPreview | null {
  if (typeof Office === "undefined" || !Office.context?.mailbox?.item) {
    return null;
  }

  const item = Office.context.mailbox.item;
  return {
    subject: item.subject || "",
    sender: item.from?.emailAddress || "Unknown sender",
  };
}
